<template lang="pug">
  div.inner
    h2 お申込みフォーム完了
    .text-center
      span 申し込みありがとうございました。<br>
      .wrap-text
        span.red-color ※ご注意ください※<br>
        span
          |ご購入手続きは完了しておりません。<br>
          |改めてメールにてご案内差し上げますので、ご確認のほど宜しくお願いいたします。<br>
          |ご案内後一週間以内にメールへのご返答、もしくはご購入手続きを頂けない場合、<br>
          |お申込みをキャンセルとさせていただきます。<br>
          |ご了承くださいませ。

    div.submit-area
      div.back(href="#",@click="backPage") 戻る
</template>

<script>
import store from '../../stores';
export default {
  name: 'Form',
  data () {
    return {
    };
  },
  props: {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    submitCheck () {
    },
    afterSubmit (dat) {
    },
    backPage () {
      this.$emit('back');
      store.commit('setFormstatus', false);
    }
  },
  created () {
    let d = new Date();
    this.selected_month = d.getMonth() + 1;
    this.selected_day = d.getDate();
    let gtag = window.gtag || false;
    if (gtag) {
      gtag('send', 'pageview', '/set/complete');
      gtag('config', this.config.ua, {'page_path': '/set/complete'});
    }
  }
};
</script>

<style lang="stylus" scoped>
.form
  background-color #ffffff
  position fixed
  z-index 10000
  left 0
  top 0
  width 100%
  height 100%
#header
  height 77px
  border-bottom 1px solid #DDDDDD
  .inner
    max-width 1040px
    padding 0 20px
    margin 0 auto
    .logo
      padding-top 27px
#main
  position absolute
  left 0
  right 0
  top 78px
  bottom 0
  overflow auto
  .inner
    max-width 1040px
    padding 50px 20px
    margin 0 auto
  h2
    text-align center
    font-size 22px
    margin-bottom 65px
  h3
    padding 5px 0 5px 17px
    border-left 5px solid #2E7C80
    margin-bottom 25px
  p
    padding 70px 0
    text-align center
    font-size 18px
  .submit-area
    display  flex
    justify-content center
    margin 0 auto 50px auto
  button,.back
    background-color #2E7C80
    font-size 20px
    font-weight bold
    color #ffffff
    border-radius 8px
    width 324px
    height 64px
    margin 0 10px
    display flex
    justify-content center
    align-items center
    text-decoration none
    cursor pointer
    &.back
      background-color #999999
      width 120px
    img
      vertical-align middle
      margin-left 10px
      display inline-block
  .wrap-text
    margin 30px 0
    .red-color
      color red
.text-center
  text-align center
</style>



// WEBPACK FOOTER //
// src/components/form/Complete.vue